import { useEffect, useState } from "react";

/**
 * `--breakpoint-min`（tokens.css）と同じ値。JSからはCSS変数を直接読めないため複製する
 * （AdvScene.tsxの`COMPANION_CROSSFADE_MS`と同じ方針）。
 */
const NARROW_BREAKPOINT_PX = 1024;

function computeIsMobileOrNarrow(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const isCoarsePointer =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(pointer: coarse)").matches &&
    window.matchMedia("(hover: none)").matches;
  return isCoarsePointer || window.innerWidth < NARROW_BREAKPOINT_PX;
}

/**
 * 携帯案内（O-3）・画面が狭い案内、共通の判定（ui-design.md §4.1・§7.8）。
 * 判定は画面幅ではなく`pointer: coarse`かつ`hover: none`が主だが、
 * 1024px未満は「画面が狭い案内」として同じ扱いにする。
 * `matchMedia`未実装環境（jsdom等）では幅のみで判定する。
 */
export function useIsMobileOrNarrow(): boolean {
  const [value, setValue] = useState(computeIsMobileOrNarrow);

  useEffect(() => {
    function update() {
      setValue(computeIsMobileOrNarrow());
    }
    window.addEventListener("resize", update);

    let pointerQuery: MediaQueryList | undefined;
    let hoverQuery: MediaQueryList | undefined;
    if (typeof window.matchMedia === "function") {
      pointerQuery = window.matchMedia("(pointer: coarse)");
      hoverQuery = window.matchMedia("(hover: none)");
      pointerQuery.addEventListener("change", update);
      hoverQuery.addEventListener("change", update);
    }

    return () => {
      window.removeEventListener("resize", update);
      pointerQuery?.removeEventListener("change", update);
      hoverQuery?.removeEventListener("change", update);
    };
  }, []);

  return value;
}
